module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/infograficaUno.98518bf7.png";